
export default {
  name: 'GiftVoucher',

  data() {
    return {
      voucherApi: new this.$ApiModel()
    }
  },

  methods: {
    async addVoucherToBasket() {
      try {
        // Booking returns current basket
        const { response } = await this.$api.discount(this.voucherApi).addToBasket()

        this.$store.commit('booking/setBasket', { basket: response.data })

        if (this.$app.isBrochureware) {
          this.$redirect.to('/book/checkout')
        } else {
          this.$redirect.to('/platform/book/checkout')
        }
      } catch (error) {
        this.$log.error('Error adding voucher to basket', error)
      }
    }
  }
}
